import styled from "styled-components";

export const FooterCopy = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
  background-color: var(--blackFooter);
  border-top: 1px solid var(--border);
  padding: 10px 20px;

  @media (max-width: 768px) {
    font-size: 12px;
    height: 40px;
  }
`;

export const TextCopy = styled.span`
  font-family: "Roboto Medium";
  font-style: italic;
  font-size: 15px;
  color: var(--textLihght);
`;
